
const { doExec } = require('./request')

module.exports = {
    // 获得当前用户的招募信息
    getRecruitStatus (opts) {
        return doExec('mobile/system/volunteer/get', opts, null, 'get')
    },
    // 保存招募信息
    submitRecruit (opts) {
      return doExec('mobile/system/volunteer/create', opts)
    }
}